<template>
    <div>
      <!-- <v-app-bar color="primary" fixed>     -->
        <v-app-bar color="primary"  absolute> 
      <div class="d-flex justify-space-between  top-bar">
      <div class="ma-2 pa-2" >
        <v-icon medium>mdi-phone</v-icon>
        Call : {{  getFooterDetails.mobileno }}
      </div>
      <div  class="ma-2 pa-2" >
        <v-icon color="#fff" small>mdi-email</v-icon> {{  getFooterDetails.email }}
      </div>
    </div>


      <!-- <v-container fluid>
        <v-row >
          <v-col cols="12" sm="12" md="4" lg="4">
            <span class="primary--text font-weight-bold">
              <span class="primary--text">
              <v-icon medium>mdi-phone</v-icon>
                Call : <span>7894561230</span> 
              </span>
            </span>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2">
            <span class="black--text"></span>
          </v-col>
          <v-col cols="12" sm="12" md="1" lg="2">
            <span class="black--text"></span>
          </v-col>
          <v-col cols="12" sm="12" md="4" lg="3" >
            <span class="black--text"><v-icon color="#fff" small>mdi-email</v-icon> test@gmail.com</span>
          </v-col>
          <v-col cols="12" sm="12" md="1" lg="1">
            <span class="black--text"></span>
          </v-col>
        </v-row>
      </v-container> -->

      </v-app-bar>
  

    </div>
  </template>
  <style scoped>
  .top-bar{
    width: 100%;
    font-size: 14px;
  }
  </style>
  <script>
  // @ is an alias to /src
import { mapActions, mapGetters } from "vuex";

import { VUE_WEB_BASEURL } from "../utils/api";
  export default {
    name: "HeaderBar",
    data: () => ({}),
    computed: {
    ...mapGetters(["getFooterDetails"]),
  },
  created() {
    this.fetchFooter();
    this.imageUrl = VUE_WEB_BASEURL;
  },
  methods: {
    ...mapActions(["fetchFooter"]),
  },
  };
  </script>
  